import React from 'react';

const styles = {
  page: {
    flex: 1,
    overflowY: 'auto',
    background: '#FAFAF8',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: 15,
    lineHeight: 1.7,
    color: '#1A1A18',
  },
  inner: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '0 20px 3rem',
  },
};

function PlaybookPage() {
  return (
    <div style={styles.page}>
      <div style={styles.inner}>
        <style>{`
          .pb h1 { font-family: 'DM Serif Display', Georgia, serif; font-size: 2.2rem; color: #8B2500; margin: 2rem 0 0.3rem; letter-spacing: -0.02em; line-height: 1.2; }
          .pb .subtitle { font-size: 0.82rem; color: #9E9B90; margin-bottom: 2rem; font-weight: 500; }
          .pb h2 { font-family: 'DM Serif Display', Georgia, serif; font-size: 1.4rem; color: #1A1A18; margin: 2.5rem 0 0.75rem; padding-bottom: 0.4rem; border-bottom: 2px solid #8B2500; display: inline-block; line-height: 1.2; }
          .pb h3 { font-family: 'DM Serif Display', Georgia, serif; font-size: 1.05rem; color: #1A1A18; margin: 1.5rem 0 0.5rem; line-height: 1.3; }
          .pb blockquote { border-left: 3px solid #D4A574; background: #FAF6F2; margin: 0.75rem 0; padding: 0.7rem 1.1rem; border-radius: 0 6px 6px 0; font-size: 0.9rem; }
          .pb blockquote strong { color: #8B2500; }
          .pb .stat-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 0.6rem; margin: 1rem 0; }
          .pb .stat { background: #fff; border: 1px solid #E8E6E0; border-radius: 8px; padding: 0.85rem; text-align: center; }
          .pb .stat-val { font-family: 'DM Serif Display', Georgia, serif; font-size: 1.7rem; color: #8B2500; line-height: 1; }
          .pb .stat-label { font-size: 0.7rem; color: #9E9B90; text-transform: uppercase; letter-spacing: 0.06em; margin-top: 0.2rem; }
          .pb .step { display: flex; gap: 0.85rem; margin: 0.6rem 0; align-items: flex-start; }
          .pb .step-num { flex-shrink: 0; width: 26px; height: 26px; background: #8B2500; color: #FAFAF8; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.72rem; font-weight: 700; margin-top: 2px; }
          .pb .card { background: #fff; border: 1px solid #E8E6E0; border-radius: 8px; padding: 1.1rem; margin: 0.75rem 0; }
          .pb .card-title { font-family: 'DM Serif Display', Georgia, serif; font-size: 0.95rem; color: #8B2500; margin-bottom: 0.4rem; }
          .pb .script-block { background: #F5F4F0; border: 1px solid #E8E6E0; border-radius: 6px; padding: 0.85rem 1.1rem; margin: 0.6rem 0; font-size: 0.85rem; line-height: 1.8; white-space: pre-wrap; }
          .pb .script-block .jade { color: #8B2500; font-weight: 600; }
          .pb .script-block .note { color: #9E9B90; font-style: italic; font-size: 0.8rem; }
          .pb table { width: 100%; border-collapse: collapse; margin: 0.75rem 0; font-size: 0.85rem; font-variant-numeric: tabular-nums; }
          .pb th { text-align: left; font-weight: 600; color: #6B6960; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.05em; padding: 0.45rem 0.65rem; border-bottom: 2px solid #E8E6E0; }
          .pb td { padding: 0.45rem 0.65rem; border-bottom: 1px solid #E8E6E0; }
          .pb .golden-rule { display: flex; gap: 0.7rem; align-items: flex-start; margin: 0.6rem 0; padding: 0.65rem 0.85rem; background: #fff; border-left: 3px solid #8B2500; border-radius: 0 6px 6px 0; }
          .pb .golden-num { flex-shrink: 0; font-family: 'DM Serif Display', Georgia, serif; font-size: 1.15rem; color: #C4705A; min-width: 1.4rem; }
          .pb .golden-text strong { color: #8B2500; }
          .pb .loss-bar { display: flex; align-items: center; gap: 0.7rem; margin: 0.35rem 0; }
          .pb .loss-label { font-size: 0.8rem; color: #6B6960; min-width: 130px; }
          .pb .loss-track { flex: 1; height: 20px; background: #F5F4F0; border-radius: 4px; overflow: hidden; }
          .pb .loss-fill { height: 100%; border-radius: 4px; display: flex; align-items: center; padding-left: 6px; font-size: 0.68rem; font-weight: 600; color: #FAFAF8; }
          .pb .highlight { color: #8B2500; font-weight: 600; }
          .pb .toc { background: #fff; border: 1px solid #E8E6E0; border-radius: 8px; padding: 1rem 1.25rem; margin: 1.25rem 0 2rem; }
          .pb .toc-title { font-size: 0.7rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #9E9B90; margin-bottom: 0.4rem; }
          .pb .toc a { display: block; color: #6B6960; text-decoration: none; font-size: 0.85rem; padding: 0.15rem 0; }
          .pb .toc a:hover { color: #8B2500; }
          .pb .sn { color: #C4705A; margin-right: 0.4rem; font-size: 0.82rem; }
          .pb hr { border: none; border-top: 1px solid #E8E6E0; margin: 2rem 0; }
          .pb ul, .pb ol { font-size: 0.9rem; padding-left: 1.25rem; }
          .pb p { margin: 0.45rem 0; }
          @media (max-width: 500px) { .pb h1 { font-size: 1.7rem; } .pb .stat-row { grid-template-columns: 1fr 1fr; } .pb .loss-label { min-width: 90px; font-size: 0.72rem; } }
        `}</style>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=Inter:wght@400;500;600;700&display=swap" />
        <div className="pb">

        <h1>Jade's Sales Playbook</h1>
        <p className="subtitle">Extracted from 75 real call transcripts &middot; 45 converted, 30 lost &middot; Amour Mobile Nails</p>

        <div className="stat-row">
          <div className="stat"><div className="stat-val">60%</div><div className="stat-label">Conversion Rate</div></div>
          <div className="stat"><div className="stat-val">5–6m</div><div className="stat-label">Avg Won Call</div></div>
          <div className="stat"><div className="stat-val">4m</div><div className="stat-label">Avg Lost Call</div></div>
          <div className="stat"><div className="stat-val">33%</div><div className="stat-label">Losses: Out of Area</div></div>
        </div>

        <div className="toc">
          <div className="toc-title">Playbook Sections</div>
          <a href="#opening"><span className="sn">1</span> The Opening</a>
          <a href="#discovery"><span className="sn">2</span> Discovery — The First 60 Seconds</a>
          <a href="#pricing"><span className="sn">3</span> Pricing Presentation</a>
          <a href="#close"><span className="sn">4</span> The Close & Credit Card</a>
          <a href="#connection"><span className="sn">5</span> Building Emotional Connection</a>
          <a href="#upsell"><span className="sn">6</span> Upselling</a>
          <a href="#lost"><span className="sn">7</span> Lost Call Patterns</a>
          <a href="#metrics"><span className="sn">8</span> Key Metrics</a>
          <a href="#script"><span className="sn">9</span> Step-by-Step Script</a>
          <a href="#rules"><span className="sn">10</span> Golden Rules</a>
        </div>

        {/* Section 1 */}
        <h2 id="opening"><span className="sn">1</span> The Opening</h2>
        <p>Jade opens every call identically. The consistency is the point — callers hear a confident, established professional.</p>
        <blockquote><strong>"Hello, good afternoon. This is Jade with our Amour Mobile Nails team. Who do I have the pleasure of speaking with?"</strong></blockquote>
        <p>The key phrase is <strong className="highlight">"pleasure of speaking with"</strong> — it sets warmth and respect that carries through the entire call. With elderly clients and their families, this formality signals trustworthiness.</p>

        {/* Section 2 */}
        <h2 id="discovery"><span className="sn">2</span> Discovery — First 60 Seconds</h2>
        <p>Jade's discovery follows a tight, consistent sequence.</p>

        <div className="step">
          <div className="step-num">1</div>
          <div><strong>Zip code first</strong> — tells her whether the area is serviceable and which technician covers it.
            <blockquote><strong>"May I have the zip code for where you are?"</strong></blockquote>
          </div>
        </div>
        <div className="step">
          <div className="step-num">2</div>
          <div><strong>Who is it for?</strong> — Changes the entire conversation.
            <blockquote><strong>"And would this be for yourself or a family member?"</strong></blockquote>
          </div>
        </div>
        <div className="step">
          <div className="step-num">3</div>
          <div><strong>What service?</strong> — She uses the word <em>"enjoy"</em> to frame it as pampering.
            <blockquote><strong>"What would you like to enjoy?"</strong></blockquote>
          </div>
        </div>
        <div className="step">
          <div className="step-num">4</div>
          <div><strong>Medical context</strong> — asked with zero awkwardness, as naturally as asking for a phone number.
            <blockquote><strong>"Does he have diabetes or blood thinners? Any limited mobility?"</strong></blockquote>
          </div>
        </div>

        {/* Section 3 */}
        <h2 id="pricing"><span className="sn">3</span> Pricing Presentation</h2>

        <div className="card">
          <div className="card-title">The Jade Pricing Formula</div>
          <ol>
            <li><strong>Delay pricing</strong> until after availability is confirmed and booking has started</li>
            <li><strong>Frame as transparency</strong>, not a sales pitch</li>
            <li><strong>Use the exact phrase:</strong></li>
          </ol>
          <blockquote style={{marginTop: '0.5rem'}}><strong>"I do want to share the cost in advance with you for your consideration. The pedicure will be just $80. Is that okay?"</strong></blockquote>
        </div>

        <ul>
          <li>Says <strong className="highlight">"just $80"</strong> — the word "just" minimizes the amount</li>
          <li>Says <strong className="highlight">"is that okay?"</strong> — gets a micro-commitment</li>
          <li>Mentions travel fees separately and casually</li>
          <li>Breaks down combos: <em>"$110 plus a ten dollar travel fee"</em></li>
        </ul>

        <h3>Service Pricing Reference</h3>
        <div style={{overflowX: 'auto'}}>
          <table>
            <thead><tr><th>Service</th><th style={{textAlign:'right'}}>Price</th></tr></thead>
            <tbody>
              <tr><td>Toenail trim only</td><td style={{textAlign:'right'}}>$30</td></tr>
              <tr><td>Manicure (regular polish)</td><td style={{textAlign:'right'}}>$35</td></tr>
              <tr><td>Pedicure (standard)</td><td style={{textAlign:'right'}}>$80</td></tr>
              <tr><td>Mani + Pedi combo</td><td style={{textAlign:'right'}}>$80–$110</td></tr>
              <tr><td>Gel polish add-on</td><td style={{textAlign:'right'}}>+$25</td></tr>
              <tr><td>Restorative foot care</td><td style={{textAlign:'right'}}>+$15</td></tr>
              <tr><td>Travel fee (standard)</td><td style={{textAlign:'right'}}>$10</td></tr>
              <tr><td>Travel fee (extended)</td><td style={{textAlign:'right'}}>$15–$40</td></tr>
              <tr><td>Hospital/bedside mani+pedi</td><td style={{textAlign:'right'}}>$150</td></tr>
            </tbody>
          </table>
        </div>

        <h3>When Price Is Rejected</h3>
        <p>Jade doesn't negotiate, discount, or get defensive. She states the value once and gracefully lets go:</p>
        <blockquote>
          Customer: <em>"No, you charge too much. Sorry."</em><br />
          <strong>"Yes, we come to you. We come directly to you. And we're experienced, licensed and professional."</strong><br /><br />
          Customer: <em>"Yeah, I like more than I want to pay."</em><br />
          <strong>"I do hope you find someone a little more affordable. But if you're open to consider… we take great care of you."</strong>
        </blockquote>

        {/* Section 4 */}
        <h2 id="close"><span className="sn">4</span> The Close & Credit Card</h2>
        <p>Jade doesn't have a "closing moment." The information-gathering <em>is</em> the booking. The customer often doesn't realize they've been closed.</p>

        <h3>Collection Sequence</h3>
        <div className="step"><div className="step-num">1</div><div>Full name</div></div>
        <div className="step"><div className="step-num">2</div><div>Phone number</div></div>
        <div className="step"><div className="step-num">3</div><div>Email (for receipts)</div></div>
        <div className="step"><div className="step-num">4</div><div>Address + gate codes / room number</div></div>
        <div className="step"><div className="step-num">5</div><div>Age + mobility notes</div></div>
        <div className="step"><div className="step-num">6</div><div>Price presentation</div></div>
        <div className="step"><div className="step-num">7</div><div>Credit card</div></div>

        <h3>The Credit Card Ask</h3>
        <blockquote><strong>"Last but not least, I just need to save a valid credit card on file for the appointment. Charge is only going to be processed after the service is completed."</strong></blockquote>
        <ul>
          <li><strong className="highlight">"save"</strong> not "charge" — sounds safer</li>
          <li><strong className="highlight">"on file"</strong> — implies standard procedure</li>
          <li><strong className="highlight">"after the service is completed"</strong> — removes the risk</li>
        </ul>

        <p>When customers hesitate:</p>
        <blockquote>
          Customer: <em>"So you want that now, is that what you're saying?"</em><br />
          <strong>"Yes. I just need to have the card information saved right now for the appointment. That's all."</strong>
        </blockquote>

        <h3>The Momentum Keeper</h3>
        <blockquote><strong>"Bear with me, I'll just be another couple minutes here."</strong></blockquote>
        <p>She says this while typing. Prevents silence from breaking the flow.</p>

        {/* Section 5 */}
        <h2 id="connection"><span className="sn">5</span> Building Emotional Connection</h2>
        <p>This is Jade's superpower. She doesn't just book — she makes people feel cared for.</p>

        <div className="card">
          <div className="card-title">With Family Members</div>
          <blockquote><strong>"I'm so glad for us to take care of mom. That's great."</strong></blockquote>
          <blockquote><strong>"He deserves it."</strong> <span style={{color:'#9E9B90',fontSize:'0.82rem'}}>— when wife says she's spoiling her husband</span></blockquote>
          <blockquote><strong>"We just love on them and that's it. Nothing more."</strong></blockquote>
        </div>
        <div className="card">
          <div className="card-title">Removing Embarrassment</div>
          <blockquote><strong>"Yeah, we love a hot mess."</strong> <span style={{color:'#9E9B90',fontSize:'0.82rem'}}>— when daughter says dad's feet are in bad shape</span></blockquote>
          <blockquote><strong>"We do this with older people. This is so common."</strong></blockquote>
          <blockquote><strong>"You don't have to do anything, that's what we're here for."</strong></blockquote>
        </div>
        <div className="card">
          <div className="card-title">Creating Fate</div>
          <blockquote><strong>"Sometimes we really believe things happen for a reason. Like this is such a sweet spot for Mom. Literally someone just canceled. And it happens to be with Amber from Boston."</strong></blockquote>
          <p style={{fontSize:'0.82rem',color:'#9E9B90',margin:0}}>She frames scheduling as fate, not logistics. The customer's mom is from Massachusetts — instant connection.</p>
        </div>

        {/* Section 6 */}
        <h2 id="upsell"><span className="sn">6</span> Upselling</h2>
        <p>Natural, never pushy. Three moments:</p>
        <div className="step">
          <div className="step-num">+</div>
          <div><strong>Fingernails when they only asked for toenails</strong>
            <blockquote><strong>"Do you want us to do fingernails too while we're there?"</strong></blockquote>
            <p style={{fontSize:'0.82rem',color:'#6B6960'}}>Upsells from $80 to $110.</p>
          </div>
        </div>
        <div className="step">
          <div className="step-num">+</div>
          <div><strong>Monthly plan</strong>
            <blockquote><strong>"Would you like us to take care of mom on a monthly basis every time we come?"</strong></blockquote>
          </div>
        </div>
        <div className="step">
          <div className="step-num">+</div>
          <div><strong>Automatic gratuity</strong>
            <blockquote><strong>"Would you like to offer any thank-you tip to Brianna, like a set amount we can note here?"</strong></blockquote>
            <p style={{fontSize:'0.82rem',color:'#6B6960'}}>Frames it as "thank you," not a tip request. Got $20 automatic gratuity from Kevin.</p>
          </div>
        </div>

        {/* Section 7 */}
        <h2 id="lost"><span className="sn">7</span> Lost Call Patterns</h2>
        <div className="loss-bar"><div className="loss-label">Out of area</div><div className="loss-track"><div className="loss-fill" style={{width:'33%',background:'#9E9B90'}}>33%</div></div></div>
        <div className="loss-bar"><div className="loss-label">"I'll call back"</div><div className="loss-track"><div className="loss-fill" style={{width:'20%',background:'#92400E'}}>20%</div></div></div>
        <div className="loss-bar"><div className="loss-label">Timing / availability</div><div className="loss-track"><div className="loss-fill" style={{width:'17%',background:'#1E4D8C'}}>17%</div></div></div>
        <div className="loss-bar"><div className="loss-label">Price rejection</div><div className="loss-track"><div className="loss-fill" style={{width:'10%',background:'#9B2C2C'}}>10%</div></div></div>
        <div className="loss-bar"><div className="loss-label">Service mismatch</div><div className="loss-track"><div className="loss-fill" style={{width:'10%',background:'#9E9B90'}}>10%</div></div></div>
        <div className="loss-bar"><div className="loss-label">Client hesitation</div><div className="loss-track"><div className="loss-fill" style={{width:'10%',background:'#9E9B90'}}>10%</div></div></div>

        <div className="card" style={{borderLeft:'3px solid #92400E',marginTop:'1rem'}}>
          <div className="card-title" style={{color:'#92400E'}}>Biggest Opportunity: "I'll Call Back"</div>
          <p style={{fontSize:'0.88rem'}}>20% of lost leads said they needed to check with family or call back. A systematic follow-up — text the next day, call 48 hours later — could convert a significant portion.</p>
        </div>

        {/* Section 8 */}
        <h2 id="metrics"><span className="sn">8</span> Key Metrics</h2>
        <div style={{overflowX:'auto'}}>
          <table>
            <thead><tr><th>Stage Where Lead Was Lost</th><th style={{textAlign:'center'}}>Count</th><th style={{textAlign:'right'}}>% of Losses</th></tr></thead>
            <tbody>
              <tr><td>Service area check</td><td style={{textAlign:'center'}}>10</td><td style={{textAlign:'right'}}>33%</td></tr>
              <tr><td>"I'll call you back"</td><td style={{textAlign:'center'}}>6</td><td style={{textAlign:'right'}}>20%</td></tr>
              <tr><td>Same-day / timing</td><td style={{textAlign:'center'}}>5</td><td style={{textAlign:'right'}}>17%</td></tr>
              <tr><td>Price presented</td><td style={{textAlign:'center'}}>3</td><td style={{textAlign:'right'}}>10%</td></tr>
              <tr><td>Service mismatch</td><td style={{textAlign:'center'}}>3</td><td style={{textAlign:'right'}}>10%</td></tr>
              <tr><td>Client hesitation</td><td style={{textAlign:'center'}}>3</td><td style={{textAlign:'right'}}>10%</td></tr>
            </tbody>
          </table>
        </div>
        <p style={{fontSize:'0.85rem',color:'#6B6960'}}>Won calls average 5–6 minutes (full booking with card). Lost calls average 4 minutes — they end before the close. Jade presents pricing at the 3–4 minute mark, after availability is confirmed.</p>

        {/* Section 9 */}
        <h2 id="script"><span className="sn">9</span> Step-by-Step Script</h2>

        <h3>Opening <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>0:00–0:15</span></h3>
        <div className="script-block"><span className="jade">"Hello, good [morning/afternoon]. This is [Name] with our Amour Mobile Nails team. Who do I have the pleasure of speaking with?"</span></div>

        <h3>Discovery <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>0:15–1:30</span></h3>
        <div className="script-block"><span className="jade">"May I have the zip code for where you are?"</span>{"\n"}<span className="note">→ Check coverage immediately</span>{"\n\n"}<span className="jade">"And would this be for yourself or a family member?"</span>{"\n"}<span className="note">→ Adjusts tone based on answer</span>{"\n\n"}<span className="jade">"What would [he/she] like to enjoy? A manicure, pedicure, or both?"</span>{"\n\n"}<span className="jade">"Does [he/she] have diabetes or any blood thinners? Any limited mobility?"</span>{"\n"}<span className="note">→ Ask naturally. Don't hesitate.</span></div>

        <h3>Schedule <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>1:30–2:30</span></h3>
        <div className="script-block"><span className="jade">"Let me check our schedule for you. Bear with me one moment."</span>{"\n"}<span className="note">→ Actually pull up the calendar while talking</span>{"\n\n"}<span className="jade">"I have a wonderful spot for [Day] around [Time]. Would that work?"</span>{"\n"}<span className="note">→ Offer ONE specific slot, not a menu of options</span></div>

        <h3>Collect Info <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>2:30–4:00</span></h3>
        <div className="script-block"><span className="jade">"May I have [his/her] first name and last name?"</span>{"\n"}<span className="jade">"What's a good phone number for us to have?"</span>{"\n"}<span className="jade">"May I have a good email for receipts?"</span>{"\n"}<span className="jade">"And the address?"</span>{"\n"}<span className="jade">"May I also take away [his/her] age?"</span>{"\n"}<span className="note">→ Say "bear with me" while entering data</span></div>

        <h3>Price <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>4:00–4:30</span></h3>
        <div className="script-block"><span className="jade">"I do want to share the cost in advance with you for your consideration. The [service] will be just $[amount]. Is that okay?"</span></div>

        <h3>Credit Card <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>4:30–5:30</span></h3>
        <div className="script-block"><span className="jade">"Last but not least, I just need to save a valid credit card on file for the appointment. Charge is only going to be processed after the service is completed."</span>{"\n\n"}<span className="note">→ If hesitation:</span>{"\n"}<span className="jade">"I just need to have the card information saved right now for the appointment. That's all."</span></div>

        <h3>Warm Close <span style={{color:'#9E9B90',fontWeight:400,fontFamily:'Inter',fontSize:'0.78rem'}}>5:30–6:00</span></h3>
        <div className="script-block"><span className="jade">"We look forward to taking wonderful care of [name]. Thank you so much. Have a wonderful day. Bye now."</span>{"\n\n"}<span className="note">→ For emotional situations:</span>{"\n"}<span className="jade">"[He/She] is going to have a wonderful experience. We just love on them."</span></div>

        {/* Section 10 */}
        <h2 id="rules"><span className="sn">10</span> Golden Rules</h2>

        <div className="golden-rule"><div className="golden-num">1</div><div><strong>Never apologize for the price.</strong> State it, ask "is that okay?," move on.</div></div>
        <div className="golden-rule"><div className="golden-num">2</div><div><strong>Use "enjoy" not "need."</strong> It's pampering, not a medical procedure.</div></div>
        <div className="golden-rule"><div className="golden-num">3</div><div><strong>Offer one slot, not a menu.</strong> "I have Wednesday at 1pm" converts better than "what day works?"</div></div>
        <div className="golden-rule"><div className="golden-num">4</div><div><strong>Collect the card as routine.</strong> "Last but not least" — administrative step, not a sales barrier.</div></div>
        <div className="golden-rule"><div className="golden-num">5</div><div><strong>Name the technician.</strong> "Adriana will come" — personal connection before they've met.</div></div>
        <div className="golden-rule"><div className="golden-num">6</div><div><strong>Say "bear with me."</strong> Silence kills momentum. This phrase keeps them on the line.</div></div>
        <div className="golden-rule"><div className="golden-num">7</div><div><strong>Ask about their life.</strong> Chickens, weather, where they moved from — trust-builders, not time-wasters.</div></div>
        <div className="golden-rule"><div className="golden-num">8</div><div><strong>Normalize the condition.</strong> "We do this with older people. This is so common."</div></div>
        <div className="golden-rule"><div className="golden-num">9</div><div><strong>"We love a hot mess."</strong> The best line in the transcripts. You're not a burden, we've seen it all.</div></div>
        <div className="golden-rule"><div className="golden-num">10</div><div><strong>Follow up on "I'll call you back."</strong> 20% of leads lost here. Same-day text + 48-hour callback.</div></div>

        <hr />
        <p style={{fontSize:'0.8rem',color:'#9E9B90',textAlign:'center',margin:'1.5rem 0'}}>
          Generated from 75 real call transcripts &middot; Amour Mobile Nails &middot; October 2026
        </p>
        </div>
      </div>
    </div>
  );
}

export default PlaybookPage;
